// extracted by mini-css-extract-plugin
export default {"update-offer-modal":"styles__update-offer-modal--lfbxu","modal-title":"styles__modal-title--9fKKI","header-container":"styles__header-container--U85jw"};